module.exports = __webpack_public_path__ + "images/emoji/sweat_smile.ec8268a9472977086be4.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/sweat_smile.png
// module id = 9+Bu
// module chunks = 2